import { Dialog, Grid, InputAdornment, TextField, Typography, Button, Icon } from '@material-ui/core'
import React, { useState, useEffect } from 'react'

import Scrollbars from "rc-scrollbars";
import eligibility_check_ico from '../../../../assets/img/stepper/eligibility_check.svg';
import review_authorize_ico from '../../../../assets/img/stepper/review_authorize.svg';
import line_information_ico from '../../../../assets/img/stepper/line_information.svg';
import profile_information_ico from '../../../../assets/img/stepper/profile_information.svg';
import existing_carrier_ico from '../../../../assets/img/stepper/existing_carrier.svg';
import figg_ico from '../../../../assets/img/stepper/figg.svg';


import CloseIcon from '@material-ui/icons/Close';
import { CustomBtn, DraggableComponent } from '../../../../components/UiElements/UiElements';

// import ReactSpeedometer from 'react-d3-speedometer';
import useStyles from "./styles";
// import RegistrationWizard from './components/RegistrationWizard'
import ExistingCarrier from './components/existingCarrier/ExistingCarrier';
import CheckEligibility from './components/checkEligibility/CheckEligibility';
import CarrierInformation from './components/carrierInformation/CarrierInformation';

import ProfileInformation from './components/carrierInformation/ProfileInformation';
import LineInformation from './components/lineInformation/LineInformation';

import ReviewAndAuthorize from './components/reviewAndAuthorize/ReviewAndAuthorize';
import OrderCompleted from './components/orderCompleted/OrderCompleted';
import { PostDataAPI } from '../../../../Services/APIService';
import Loader from './../../../../components/Loader/Loader';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { withSnackbar } from "./../../../../components/Message/Alert";
import { GetUserInfo } from "../../../../Services/GetUserInfo";
import { formateMdnNumber, maskAccountNumber, saveActivlityLogInfo } from '../../../../../src/components/Common/Extensions';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import axios from 'axios';
function NewRegistrationDialog({ dialogOpenClose, handleClose, isPrepaid, userDate, updatedBillingInfoDashboard, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [customerInfo, setCustomerInfo] = useState({});
    const [objReview, setObjReview] = useState({});
    let user_info = JSON.parse(GetUserInfo());
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [customerID] = useState(user_info.user.customerID);
    const [selectedMSISDN, setSelectedMSISDN] = useState("");
    const [activeStep, setActiveStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const steps = [

        {
            name: 'Check Eligibility',
            Icon: eligibility_check_ico,
            page: 0,
        },
        {
            name: 'Existing Carrier Information',
            Icon: existing_carrier_ico,
            page: 1,
        },
        {
            name: 'Profile Information',
            Icon: profile_information_ico,
            page: 2,
        },

        {
            name: 'Line Information',
            Icon: line_information_ico,
            page: 3,
        },
        {
            name: 'Review & Authorize',
            Icon: review_authorize_ico,
            page: 4,
        },
        {
            name: 'Complete Order',
            Icon: figg_ico,
            page: 5,
        }
    ];

    const logPortInActivity = (activity, details) => {
        saveActivlityLogInfo("Line Management", activity, details, accountNumber, customerID);
    };
    const getStepName = (stepIndex = activeStep) => {
        return steps[stepIndex]?.name || "Port In";
    };
    const maskLast4 = (value) => {
        const digits = (value || "").toString().replace(/\D/g, "");
        if (!digits)
            return "not available";
        return `****${digits.slice(-4)}`;
    };
    const getCarrierName = (data) => {
        if (!data)
            return "";
        return data.existingCarrier == "Other" ? data.otherCarrier : data.existingCarrier;
    };
    const buildPortSummary = (data) => {
        const source = typeof data === "string" ? { msisdn: data } : (data || objReview || {});
        const parts = [];
        const line = source.msisdn || selectedMSISDN;
        const carrier = getCarrierName(source);
        const plan = source.wirelessPlanType || source.packageName || source.activationPlanId;

        if (line)
            parts.push(`line ${formateMdnNumber(line)}`);
        if (carrier)
            parts.push(`carrier ${carrier}`);
        if (source.oldCarrierAccountNumber)
            parts.push(`carrier account ${maskLast4(source.oldCarrierAccountNumber)}`);
        if (source.icc || source.ICC)
            parts.push(`SIM ICC ${maskLast4(source.icc || source.ICC)}`);
        if (plan)
            parts.push(`plan ${plan}`);

        return parts.length > 0 ? parts.join(", ") : `account ${maskAccountNumber(accountNumber)}`;
    };

    const handleBack = () => {
        logPortInActivity(
            "Port In Back Clicked",
            `User clicked Back on ${getStepName()} step and moved to ${getStepName(Math.max(activeStep - 1, 0))}. ${buildPortSummary()}`
        );
        if (activeStep !== 0 && activeStep > 0) {
            setActiveStep(activeStep - 1);
        } else {
            setActiveStep(0);
        }
    }
    const [triggerEligibilityNext, setTriggerEligibilityNext] = useState(false);
    const [triggerCarrierInformation, setTriggerCarrierInformation] = useState(false);
    const [triggerProfileInformation, setTriggerProfileInformation] = useState(false);
    const [triggerLineInfoNext, setTriggerLineInfoNext] = useState(false);
    const [triggerRevNAuthNext, setTriggerRevNAuthNext] = useState(false);
    
    const handleNext = () => {
        logPortInActivity(
            activeStep === 4 ? "Port In Submit Button Clicked" : "Port In Next Clicked",
            `User clicked ${activeStep === 4 ? "submit" : "Next"} on ${getStepName()} step. ${buildPortSummary()}`
        );
        if (activeStep !== 0 && activeStep !== 1 && activeStep !== 2 && activeStep !== 3 && activeStep !== 4 && activeStep < steps?.length) {
            setActiveStep(activeStep + 1);
        }
        switch (activeStep) {
            case 0:
                setTriggerEligibilityNext(!triggerEligibilityNext);
                break;
            case 1:
                setTriggerCarrierInformation(!triggerCarrierInformation);
                break;
            case 2:
                setTriggerProfileInformation(!triggerProfileInformation);
                break;    
            case 3:
                setTriggerLineInfoNext(!triggerLineInfoNext);
                break;     
            case 4:
                setTriggerRevNAuthNext(!triggerRevNAuthNext);
                break;
            default:
                break;
        }

    }

    const handleComponentNext = (data) => {
        logPortInActivity(
            activeStep === 4 ? "Port In Request Completed" : "Port In Step Completed",
            `User completed ${getStepName()} step. ${buildPortSummary(data)}${steps[activeStep + 1] ? `. Next step: ${getStepName(activeStep + 1)}` : ""}`
        );
        if (activeStep == 0) {
            setSelectedMSISDN(data);
            data = { msisdn : data }
        }
        setObjReview(data);
        setActiveStep(activeStep + 1);

    }

    const updatedBillingInfo = (_updateBillingInfo) => {
        setCustomerInfo(prevState => ({
            ...prevState,
            billingAddress1: _updateBillingInfo.address1,
            billingAddress2: _updateBillingInfo.address2,
            billingCity: _updateBillingInfo.city,
            billingState: _updateBillingInfo.state,
            billingZip: _updateBillingInfo.zip,
            billingName: _updateBillingInfo.billingName,
            creditCardExpiration: _updateBillingInfo.ccExpMonth + '/' + _updateBillingInfo.ccExpYear,
            creditCardNumber: _updateBillingInfo.creditCardNumber,
            creditCardType: _updateBillingInfo.creditCardType,
            creditCardExpirationCvv: _updateBillingInfo.creditCardExpirationCvv
        }));
        updatedBillingInfoDashboard(_updateBillingInfo);
    }



    const AnyReactComponent = ({ text }) => <div>{text}</div>;

    function getStepContent(steps) {
        const isLastStep = (activeStep === steps.length - 1);
        switch (steps) {
            case 0:
                return <CheckEligibility
                    handleNext={(msisdn) => { handleComponentNext(msisdn) }}
                    triggerEligibilityNext={triggerEligibilityNext}
                    updateTrigger={() => { setTriggerEligibilityNext(false) }}
                    msisdn={selectedMSISDN}
                    setLoaderVisible={() => { setIsLoading(true) }}
                    setLoaderHide={() => { setIsLoading(false) }}
                />
            case 1:
                return <CarrierInformation
                    handleNext={(data) => { handleComponentNext(data) }}
                    triggerCarrierInformation={triggerCarrierInformation}
                    updateTrigger={() => { setTriggerCarrierInformation(false) }}
                    data={objReview}
                    isPrepaid={isPrepaid}
                    simPrice={simPrice}
                    setLoaderVisible={() => { setIsLoading(true) }}
                    setLoaderHide={() => { setIsLoading(false) }}
                    customerData={customerInfo}
                    updateBillingInfo={updatedBillingInfo}
                    msisdn={selectedMSISDN}
                />
            case 2:
                return <ProfileInformation
                    handleNext={(data) => { handleComponentNext(data) }}
                    triggerProfileInformation={triggerProfileInformation}
                    updateTrigger={() => { setTriggerProfileInformation(false) }}
                    data={objReview}
                    isPrepaid={isPrepaid}
                    simPrice={simPrice}
                    setLoaderVisible={() => { setIsLoading(true) }}
                    setLoaderHide={() => { setIsLoading(false) }}
                />
            case 3:
                return <LineInformation
                    handleNext={(data) => { handleComponentNext(data) }}
                        triggerLineInfoNext={triggerLineInfoNext}
                        updateTrigger={() => { setTriggerLineInfoNext(false) }}
                        data={objReview}
                        isPrepaid={isPrepaid}
                        simPrice={simPrice}
                        setLoaderVisible={() => { setIsLoading(true) }}
                        setLoaderHide={() => { setIsLoading(false) }}
                    />
            case 4:
                return <ReviewAndAuthorize
                    handleNext={handleComponentNext}
                    triggerRevNAuthNext={triggerRevNAuthNext}
                    updateTrigger={() => { setTriggerRevNAuthNext(false) }}
                    data={objReview}
                    msisdn={selectedMSISDN}
                    simPrice={simPrice}
                    customerData={customerInfo}
                    setLoaderVisible={() => { setIsLoading(true) }}
                    setLoaderHide={() => { setIsLoading(false) }}
                    isPrepaid={isPrepaid}
                />

            case 5:
                return <OrderCompleted
                    msisdn={objReview.msisdn}
                    fromCarrier={objReview.existingCarrier}
                    data={objReview}
                    simPrice={simPrice}
                    setLoaderVisible={() => { setIsLoading(true) }}
                    setLoaderHide={() => { setIsLoading(false) }}
                />
            default:
                return <>Default</>

        }
    }
    const [simPrice, setSimPrice] = useState(0);
    const getSIMProductPrice = () => {

        var params = {
            code: "get_product_by_code",
            parameters: ['sim']
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {
                setSimPrice(result.data[0].t1 ? result.data[0].t1 : 0);
            }
        })
    }

    const getCustomerInformation = () => {
        //getOnlyCustomerInformation
        debugger;
        var obj = { AccountNumber: accountNumber };
        setIsLoading(true);
        PostDataAPI("telispire/getCustomerDetail", obj, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                setCustomerInfo(result.data.objCustomerInfo)
            }
           
        })
    }

    useEffect(() => {
        if (!props.fromDashboard) {
            logPortInActivity(
                "Port In Dialog Opened",
                `User opened Port In dialog for account ${maskAccountNumber(accountNumber)}`
            );
        }
        getCustomerInformation()
        //getSIMProductPrice();
    }, []);

    const handleDialogClose = () => {
        logPortInActivity(
            "Port In Dialog Closed",
            `User closed Port In dialog on ${getStepName()} step. ${buildPortSummary()}`
        );
        handleClose();
    };

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
                maxWidth="lg"
                {...props} >

                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Port a Number{selectedMSISDN? -selectedMSISDN: ''}</Typography>
                            <Icon className={classes.closeIcon} onClick={handleDialogClose} color="white"><CloseIcon /></Icon>
                        </div>

                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <Scrollbars autoHeight autoHeightMax={570}>
                        <div className={classes.content}>
                           
                                <Grid container className={classes.container}>
                                    <Grid item lg={12} className={classes.stepContainer}>
                                        <ul className={classes.setist}>
                                            {
                                                steps?.map((stepItem, i) => {
                                                    return <li key={i}>
                                                        {
                                                            <div className={activeStep == i ? classes.activeStep: classes.inactiveStep}>
                                                                <div className={'setupImg'}><img src={stepItem.Icon} /></div>
                                                                <h4>{stepItem.name}</h4>
                                                            </div>
                                                        }
                                                    </li>
                                                })
                                            }
                                        </ul>

                                        <div className={classes.containerSection}>
                                            {getStepContent(activeStep)}
                                        </div>

                                    </Grid>
                                </Grid>
                            
                        </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                {activeStep != 5 ?
                                    <>
                                         {activeStep != 0 ? <CustomBtn id="back" size="medium" className={classes.backBtn}  onClick={handleBack}>Back</CustomBtn>: '' }
                                        <CustomBtn id="next" size="medium" className={classes.changeBtn}  onClick={handleNext} >Next</CustomBtn></>
                                    : ''}
                            </div>
                        </div>

                      

                        
                    </div>
                </div >
                {/* </Dialog > */}
                {/* <RegistrationWizard
                            dialogOpenClose={registrationWizardState}
                            handleClose={() => setRegistrationWizardState(false)}
                            onBack={handleBack}
                            onNext={handleNext}
                        /> */}
            </Dialog>
        </>

    )
}
export default withSnackbar(NewRegistrationDialog);
